import styled from "styled-components";

const NavStyle: any = styled.div`
  min-height: calc(100% - 72px);
  display: grid;
  grid-template-rows: 1fr 56px;

  .options {
    display: grid;
    grid-template-rows: auto auto auto auto auto auto auto auto auto 1fr;
    grid-gap: 8px;
  }

  .title {
    height: 24px;
    margin: 24px 0 0px;
    font-weight: 600;
    opacity: 0.6;
    color: ${(p) => p.theme.palette.primary.contrastText};
    padding: 0 24px;
  }

  .nav-link {
    height: 44px;
    text-decoration: none;
    padding: 0px 16px 0px 32px;
    display: grid;
    align-items: center;
    border-left: 4px solid transparent;
    cursor: pointer;
    &:hover {
      background-color: ${(p) => p.theme.opacityMask4};
    }
  }

  .name {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .active {
    border-left: 4px solid #fff;
    opacity: 1;
  }

  .footer {
    min-height: 56px;
    padding: 0 24px;
    position: relative;
    display: grid;
    grid-template-columns: 36px 36px 1fr;
    overflow: hidden;
    overflow-wrap: break-word;
    white-space: normal;
    align-items: center;
    justify-content: ${(props: any) =>
      props.openedDrawer ? "start" : "center"};
    background-color: ${(p) => p.theme.palette.primary.dark};
  }

  .faBtn {
    min-width: 36px;
    min-height: 36px;
    background-color: transparent;
    color: ${(p) => p.theme.iconForeground} !important;
    border: none;
    border-radius: 0;
    padding: 0;
    cursor: pointer;
    &:hover {
      background-color: ${(p) => p.theme.opacityMask4};
    }
  }

  .fa-icon {
    font-size: 20px;
  }
`;

export default NavStyle;
